import { BaseProxy } from "@/proxies/BaseProxy";

export class MessageProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `messages`,
      parameters,
    });
  }
}
